import * as PropTypes from 'prop-types';
import { ComponentType } from 'react';
import { IndexableObject } from '../types';
import * as decorators from './decorators';

/**
 * Takes a component and returns the propTypes for that component
 * where all required props with a default value are made optional.
 * This is intended to make wrapper component prop types easier
 * to construct.
 */
export function wrapPropTypes(
  component:
    | { propTypes?: IndexableObject; defaultProps?: IndexableObject }
    | ComponentType<any>,
  omitted?: string[]
) {
  const result: IndexableObject = {};
  const omittedKeys = omitted ? new Set(omitted) : undefined;
  if (component.propTypes) {
    for (const key of Object.keys(component.propTypes)) {
      if (omittedKeys && omittedKeys.has(key)) {
        continue;
      }
      let original = component.propTypes[key];
      if (typeof original !== 'function') {
        original = PropTypes.any;
      }
      const required = !original.isRequired;
      const hasDefault =
        'defaultProps' in component && component.defaultProps != null
          ? Object.prototype.hasOwnProperty.call(component.defaultProps, key)
          : false;

      if (required && hasDefault) {
        // in this case we have no reference back to the non-required version
        result[key] = decorators.notRequired(original);
      } else {
        result[key] = original || component.propTypes.any;
      }
    }
  }
  return result;
}
